import { formatRemainTime } from "../../../utils/Date";
import { useGiltContext } from "../Context/GiltContext";

const VestingTime = () => {
  const { remainingTime } = useGiltContext();
  return formatRemainTime(remainingTime, { maxPeriod: 1 });
};

export default VestingTime;
